<template>
<v-layout align-start>
    <v-flex>
        <section class="">
            <div class="caja_banner">
                <div class="tiene_logo"><img src="https://recursos.digital.nl.gob.mx/assets/img/logos/logo_cabeza_leon_nl_blanco.svg" alt="Cerro mitras">
                    <h4>Secretaría de Movilidad y Planeación Urbana</h4>
                    <h1 style="color: white;">Histórico de contratos</h1>
                </div>
                <div class="banner_cover portada_1"></div>
            </div>
        </section>
        <!--<v-card dark>
            <v-img src="http://recursos.digital.nl.gob.mx/assets/img/fondos/cerro_mitras.png" class="grey lighten-2" height="450" width="100%">
                <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(228, 114, 0, 0.7);" ></div>
                <div style="position: absolute; top: 20%; left: 47%; transform: translateX(-38%); text-align: center;" >
                <v-img src="https://smpu.nl.gob.mx/acceso/assets/leon_NL_blanco.png" alt="Logo León blanco" max-width="150" class="mx-auto"></v-img>
                    <h2 class="white--text mt-4">Secretaría de Movilidad y Planeación Urbana</h2>
                </div>
                <div style="position: absolute; bottom: 10%; width: 100%;">
                <v-row class="fill-height pa-3">
                    <v-col cols="12" md="8" offset-md="1" class="d-none d-md-block">
                        <h1 class="display-2 font-weight-bold white--text">
                            Histórico de contratos
                        </h1>
                    </v-col>
                    <v-col cols="10" offset="1" class="d-block d-md-none">
                        <h1 class="headline font-weight-bold white--text">
                            Histórico de contratos
                        </h1>
                    </v-col>
                </v-row>
                </div>
            </v-img>
        </v-card>-->
        <v-spacer></v-spacer>
                <div class="container">
                    <div class="region region-breadcrumb">
                        <nav aria-label="breadcrumb">
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item"><a href="/web/Inicio">Inicio</a></li>
                                <li class="breadcrumb-item" :class="{ active: tab === 'Listado' }"><a href="#" @click.prevent="tab = 'Listado'">Listado</a></li>
                                <li class="breadcrumb-item" v-if="tab === 'Conceptos' || seleccionado" :class="{ active: tab === 'Conceptos' }"><a href="#" @click.prevent="tab = 'Conceptos'">Conceptos</a></li>
                            </ol>
                        </nav>
                        <!--<nav key="Conceptos" href="#Conceptos" style="display:none;" ripple>
                            Conceptos
                        </nav>-->
                    </div>
                </div>
            <transition name="cortina" mode="out-in">
                <div v-if="tab === 'Listado'" key="Listado" class="modulo-tab">
                    <div class="card flat">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-6">
                                    <br>
                                    <v-range-slider v-model="rangoCosto" label="Costo" :min="0" :max="costoMax" @change="filtrar()"></v-range-slider>
                                    <span>{{"$"+ new Intl.NumberFormat("en-US").format(rangoCosto[0])+".00"}} -- </span>

                                    <span>{{"$"+ new Intl.NumberFormat("en-US").format(rangoCosto[1])+".00"}}</span>
                                </div>

                                <div class="col-12 col-md-6">
                                    <select id="selector" class="form-select" v-model="parmAnio" @change="filtrar()">
                                        <option value="">-Año-</option>
                                        <option v-for="año in orderAnios" :key="año">{{ año }}</option>
                                    </select>
                                </div>

                                <div class="col-12 col-md-6">
                                    <select id="selector" class="form-select" v-model="parmTipo" @change="filtrar()">
                                        <option value="">-Tipo de Obra-</option>
                                        <option v-for="tipo in tipoObras" :key="tipo">{{ tipo }}</option>
                                    </select>
                                </div>

                                <div class="col-12 col-md-6">
                                    <select id="selector" class="form-select" v-model="parmDependencia" @change="filtrar()">
                                        <option value="">-Dependencia-</option>
                                        <option v-for="dep in dependencias" :key="dep">{{ dep }}</option>
                                    </select>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-12 col-md-4">
                                    <label for="id" class="form-label">Contrato</label>
                                    <input id="id" class="form-control" type="text" v-model="contrato" @keyup="filtrar()" name="Contrato">
                                </div>
                                <div class="col-12 col-md-4">
                                    <label for="id" class="form-label">Empresa</label>
                                    <input id="id" class="form-control" type="text" v-model="empresa" @keyup="filtrar()" name="Empresa">
                                </div>
                                <div class="col-12 col-md-4">
                                    <label for="id" class="form-label">Obra</label>
                                    <input id="id" class="form-control" type="text" v-model="obra" @keyup="filtrar()" name="Obra">
                                </div>
                            </div>
                        </div>

                        <!--<v-card-text>
                            Listado de Contratos
                            <v-data-table v-model="selected" :sort-by.sync="sort" :sort-desc.sync="desc" :headers="headers" :items="listadoFiltro" :single-select=true item-key="contratoId" class="elevation-1" dense @click:row="mostrarItem">
                                <template v-slot:top>

                                    <v-toolbar flat color="white">

                                    </v-toolbar>
                                </template>
                                <template slot="item.montoTotal" slot-scope="{ item }">
                                    {{"$" + new Intl.NumberFormat("en-US").format(item.montoTotal)}}
                                </template>

                                <template v-slot:no-data>
                                    <v-btn color="primary" @click="listar">Actualizar</v-btn>
                                </template>
                            </v-data-table>

                        </v-card-text>-->
                    

                        <!--Listado de Contratos-->
                        <table class="estilo_tabla">
                            <thead>
                                <tr>
                                    <th scope="col" v-for="header in headers" :key="header.text" style="background-color: #FF8C1C; color: white;">{{ header.text }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="listado in listadoPaginado" :key="listado.contratoId" @click="mostrarItem(listado)">
                                    <td scope="row">{{listado.numeroContrato}}</td>
                                    <td>{{listado.empresa}}</td>
                                    <td>{{listado.tiposObra}}</td>
                                    <td>{{listado.periodo}}</td>
                                    <td>{{listado.obra}}</td>
                                    <td>{{"$" + new Intl.NumberFormat("en-US").format(listado.montoTotal)}}</td>
                                    <td>{{listado.estatus}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <div class="tabla_footer">
                            <div class="seccion_paginacion">
                                <div class="paginacion_resumen">
                                    <span>Mostrando registros del </span><b>{{ indiceInicial }} </b><span>al </span><b>{{ indiceFinal }}</b><span> de un total de </span><b>{{ listadoFiltro.length }}</b><span> resultados</span>
                                </div>
                                <div class="paginacion_paginas">
                                    <select id="selector" v-model="limite"  @change="paginaActual = 1" class="form-select mx-4" style="height: 40px; border-color: transparent;">
                                        <option v-for="opcion in opciones" :key="opcion.index">{{ opcion }}</option>
                                    </select>
                                    
                                    <button v-if="limite !== 'Todos'" :disabled="paginaActual === 1" @click="paginaAnterior" class="bi bi-chevron-left" style="border-color: transparent;"></button>
                                    <button v-if="limite !== 'Todos'" :disabled="paginaActual >= totalPaginas" @click="paginaSiguiente" class="bi bi-chevron-right" style="border-color: transparent;"></button>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <div v-if="tab === 'Conceptos'" key="Conceptos" class="modulo-tab">
                    <div class="card flat">
                        <div class="container text-center">
                            <h2 class="titulo_tarjeta"><b>Contrato: </b><span style="color: #FF8C1C;">{{seleccionado}}</span></h2>
                            <br>
                            <h3>{{descripcion}}</h3>
                        </div>
                        
                        <div class="container">
                            <div class="row justify-content-center align-items-start">
                                <div class="col-12 col-md-6 text-center mb-4">
                                    <h2>Porcentajes de Avance</h2>
                                        <section class="seccion_actividades">
                                        <div class="actividades_tarjetas">
                                            <div class="ico_actividades">
                                                <img decoding="async" src="https://recursos.digital.nl.gob.mx/assets/img/muestras/parques_dorado.svg" alt="icono de ejemplo">
                                            </div>
                                            <div class="conteo_actividades">
                                                <span class="contador es_porcentaje" data-value="80">{{avanceFinanciero}}%</span>
                                            </div>
                                            <div class="nombre_actividad">Avance Financiero</div>
                                        </div>

                                        <div class="actividades_tarjetas">
                                            <div class="ico_actividades">
                                                <img decoding="async" src="https://recursos.digital.nl.gob.mx/assets/img/muestras/parques_dorado.svg" alt="icono de ejemplo">
                                            </div>
                                            <div class="conteo_actividades">
                                                <span class="contador es_porcentaje" data-value="80">{{avanceFisico}}%</span>
                                            </div>
                                            <div class="nombre_actividad">Avance Físico</div>
                                        </div>
                                        </section>
                                    <!-- </div> -->
                                </div>

                                <div class="col-12 col-md-6 text-center mb-4">
                                    <h2>Ubicación</h2>
                                    <gmap-map
                                        :center="mapCenter"
                                        :zoom="14"
                                        style="width: 100%; height: 300px;">

                                        <gmap-marker
                                            :position="mapCenter"
                                            :clickable="true"
                                            :draggable="false"
                                        />
                                    </gmap-map>
                                    <!--<div><p class="text-center"><b>{{ myCoordinates.lat }} , {{ myCoordinates.lng }}</b></p></div>-->
                                </div>
                            </div>
                        </div>

                        <!--<v-card-text>
                            Listado de Conceptos
                            <v-data-table v-model="selected" :headers="headersConceptos" :items="listadoConceptos" :single-select=true item-key="idConcepto" dense class="elevation-1">
                                <template v-slot:top>
                                    <v-toolbar flat color="white">
                                    </v-toolbar>
                                </template>
                                <template v-slot:no-data>
                                    <v-btn color="primary" @click="listar">Actualizar</v-btn>
                                </template>
                                <template slot="item.importeTotal" slot-scope="{ item }">
                                    {{"$" + new Intl.NumberFormat("en-US").format(item.importeTotal)}}
                                </template>

                            </v-data-table>

                        </v-card-text>-->

                        <!--Listado de Conceptos-->
                        <table class="estilo_tabla">
                            <thead>
                                <tr>
                                    <th scope="col" v-for="headerConcepto in headersConceptos" :key="headerConcepto.text" style="background-color: #FF8C1C; color: white;">{{ headerConcepto.text }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="listado in listadoPaginadoConceptos" :key="listado.idConcepto">
                                    <td>{{ listado.idConcepto }}</td>
                                    <td>{{ listado.concepto }}</td>
                                    <td>{{ listado.unidad }}</td>
                                    <td>{{ listado.importeTotal }}</td>
                                </tr>
                            </tbody>
                        </table>
                        
                        <div class="tabla_footer">
                            <div class="seccion_paginacion">
                                <div class="paginacion_resumen">
                                    <span>Mostrando registros del </span><b>{{ indiceInicialConceptos }} </b><span>al </span><b>{{ indiceFinalConceptos }}</b><span> de un total de </span><b>{{ listadoConceptos.length }}</b><span> resultados</span>
                                </div>
                                <div class="paginacion_paginas">
                                    <select id="selector" v-model="limiteConceptos" @change="paginaActualConceptos = 1" class="form-select mx-4" style="height: 40px; border-color: transparent;">
                                        <option v-for="opcion in opciones" :key="opcion.index">{{ opcion }}</option>
                                    </select>

                                    <button v-if="limiteConceptos !== 'Todos'" :disabled="paginaActualConceptos === 1" @click="paginaAnteriorConceptos" class="bi bi-chevron-left" style="border-color: transparent;"></button>
                                    <button v-if="limiteConceptos !== 'Todos'" :disabled="paginaActualConceptos >= totalPaginasConceptos" @click="paginaSiguienteConceptos" class="bi bi-chevron-right" style="border-color: transparent;"></button>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
    </v-flex>
</v-layout>
</template>

<script>
import axios from 'axios'
export default {
    data: () => ({
        avanceFisico: 0,
        avanceFinanciero: 0,
        idConcurso: 0,
        opciones: [10, 15, 20, 'Todos'],
        limite: 10, paginaActual: 1,
        limiteConceptos: 10, paginaActualConceptos: 1,
        tab: 'Listado',
        seleccionado: '',
        sort:'contratoId',
        desc:true,
        listadoCompontente1: [],
        listadoFiltro: [],
        listadoConceptos: [],
        dialog: false,
        costoMax: 10,
        search: '',
        rangoCosto: [],
        selected: [],
        parmAnio: '',
        parmTipo: '',
        parmDependencia: '',
        años: [],
        tipoObras: [],
        dependencias: [],
        descripcion: '',
        headers: [{
                text: 'Contrato',
                value: 'numeroContrato',
                class: "indigo white--text title",
            },
            {
                text: 'Empresa',
                value: 'empresa',
                class: "indigo white--text title",
            },
            {
                text: 'Tipos de obra',
                value: 'tiposObra',
                class: "indigo white--text title",
            },
            {
                text: 'Año',
                value: 'periodo',
                class: "indigo white--text title",
            },
            {
                text: 'Obra',
                value: 'obra',
                class: "indigo white--text title",
            },
            {
                text: 'Importe inc. IVA',
                value: 'montoTotal',
                class: "indigo white--text title",
            },
            {
                text: 'Estatus',
                value: 'estatus',
                class: "indigo white--text title",
            },
        ],
        headersConceptos: [{
                text: 'Id',
                value: 'idConcepto',
                class: "indigo white--text title",
            },
            {
                text: 'Concepto',
                value: 'concepto',
                class: "indigo white--text title",
            },
            {
                text: 'Unidad',
                value: 'unidad',
                class: "indigo white--text title",
            },
            {
                text: 'Total',
                value: 'importeTotal',
                class: "indigo white--text title",
            },
        ],
        editedIndex: -1,
        defaultItem: {
            ContratoId: '',
            Empresa: '',
            Periodo: '',
            Obra: '',
            MontoTotal: '',
            Estatus: ''
        },
        valida: 0,
        validaMensaje: [],
        lat: 0,
        lng: 0,
        coordenadas: '',
        myCoordinates: {
            lat: 0,
            lng: 0
        }
    }),

    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'Nuevo registro' : 'Editar registro'
        },

        mapCenter() {
            if (!this.coordenadas.length) {
                return {
                    lat: 10,
                    lng: 10
                }
            }
            return {                                 
                lat: parseFloat(this.lat),
                lng: parseFloat(this.lng)
                }
            },
        
        totalPaginas() {
            if (this.limite === 'Todos' || !this.listadoFiltro.length) return 1;
            return Math.ceil(this.listadoFiltro.length / Number(this.limite));
        },

        listadoOrdenado() {
            if (!this.listadoFiltro || !this.listadoFiltro.length) return [];
            return [...this.listadoFiltro].sort((a, b) => {

                const valA = String(a.numeroContrato || '').trim();
                const valB = String(b.numeroContrato || '').trim();
                const esNumA = /^\d+$/.test(valA);
                const esNumB = /^\d+$/.test(valB);

                if (esNumA && esNumB) {
                    return Number(valB) - Number(valA);
                }

                if (esNumA && !esNumB) return -1;

                if (!esNumA && esNumB) return 1;

                return valA.localeCompare(valB, undefined, { numeric: true, sensitivity: 'base' });

            })
        },
        
        listadoPaginado() {
            if (this.limite === 'Todos') {
                return this.listadoOrdenado;
            }
            const inicio = (this.paginaActual - 1) * Number(this.limite);
            const fin = inicio + Number(this.limite);
            return this.listadoOrdenado.slice(inicio, fin);
        },

        indiceInicial() {
            if (!this.listadoFiltro.length) return 0;
            if (this.limite === 'Todos') return 1;
            return (this.paginaActual - 1) * Number(this.limite) + 1;
        },

        indiceFinal() {
            if (this.limite === 'Todos') return this.listadoFiltro.length;
            const fin = this.paginaActual * Number(this.limite);
            return fin > this.listadoFiltro.length ? this.listadoFiltro.length : fin;
        },

        totalPaginasConceptos() {
            if (this.limiteConceptos === 'Todos' || !this.listadoConceptos.length) return 1;
            return Math.ceil(this.listadoConceptos.length / Number(this.limiteConceptos));
        },

        listadoPaginadoConceptos() {
            if (this.limiteConceptos === 'Todos') {
                return this.listadoConceptos;
            }
            const inicio = (this.paginaActualConceptos - 1) * Number(this.limiteConceptos);
            const fin = inicio + Number(this.limiteConceptos);
            return this.listadoConceptos.slice(inicio, fin);
        },

        indiceInicialConceptos() {
            if (!this.listadoConceptos.length) return 0;
            if (this.limiteConceptos === 'Todos') return 1;
            return (this.paginaActualConceptos - 1) * Number(this.limiteConceptos) + 1;
        },

        indiceFinalConceptos() {
            if (this.limiteConceptos === 'Todos') return this.listadoConceptos.length;
            const fin = this.paginaActualConceptos * Number(this.limiteConceptos);
            return fin > this.listadoConceptos.length ? this.listadoConceptos.length : fin;
        },

        orderAnios(){
            return [...this.años].sort((a,b) => a - b);
        }
    },

    watch: {
        dialog(val) {
            val || this.close()
        },
        
        listadoFiltro() {
            this.paginaActual = 1;
        },

        listadoConceptos() {
            this.paginaActualConceptos = 1;
        }
    },

    created() {
        this.listar();
        this.obra = "";
        this.empresa = "";
        this.contrato = "";
    },

    methods: {

        listar() {
            //Enlistar registos
            //Llena el listado del componente con los registros que se obtengan al ejecutar la acción "Listar" del api/controller

            let me = this;
            // let header = {"Authorization":"Bearer " + this.$store.state.token};
            // let configuration={headers:header};
            axios.get('api/historicoContratos/listarPublico').then(function (response) {
                console.log(response.data);
                me.listadoCompontente1 = response.data;
                me.listadoFiltro = me.listadoCompontente1;
                // me.formatoMonto();
                me.obtenerRangoCosto();
                me.listarAños();
                me.listarTiposObra();
                me.listarDependencias();

            }).catch(function (error) {
                //Se agrega elemento a la lista por default
                me.listadoCompontente1.push({
                    contratoId: '1',
                    empresa: 'A',
                    periodo: '2018',
                    obra: 'A',
                    montoTotal: '15000000',
                    estatus: 'A'
                });
                me.listadoCompontente1.push({
                    contratoId: '2',
                    empresa: 'B',
                    periodo: '2019',
                    obra: 'B',
                    montoTotal: '20000000',
                    estatus: 'B'
                });
                console.log(error);
            });
        },
        // formatoMonto() {
        //     let me = this;
        //     me.listadoFiltro.forEach(x => x.montoTotal = "$" + new Intl.NumberFormat("en-US").format(x.montoTotal))
        // },
        listarAños() {
            let me = this;
            var listadoAños = [];
            me.listadoCompontente1.forEach(x => {
                listadoAños.push(x.periodo)
            });

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            me.años = listadoAños.filter(onlyUnique);
            console.log(me.años)
        },
        listarTiposObra() {
            let me = this;
            var listadoTipoObras = [];
            me.listadoCompontente1.forEach(x => {
                listadoTipoObras.push(x.tiposObra)
            });

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            me.tipoObras = listadoTipoObras.filter(onlyUnique);
            console.log(me.tipoObras)
        },
        listarDependencias() {
            let me = this;
            var listadoDependencias = [];
            me.listadoCompontente1.forEach(x => {
                listadoDependencias.push(x.dependencia)
            });

            function onlyUnique(value, index, self) {
                return self.indexOf(value) === index;
            }
            me.dependencias = listadoDependencias.filter(onlyUnique);
            console.log(me.dependencias)
        },
        obtenerRangoCosto() {
            let me = this;
            var listadoCostos = [];
            me.listadoCompontente1.forEach(x => {
                listadoCostos.push(x.montoTotal)
            });

            me.costoMax = Math.max(...listadoCostos);
            me.costoMax = Math.trunc(me.costoMax) + 1;
            me.rangoCosto.push(0);
            me.rangoCosto.push(me.costoMax);
            console.log(me.rangoCosto);
            console.log(me.costoMax)

        },
        filtrar() {
            let parmObra = this.obra.toUpperCase();
            let parmEmpresa = this.empresa.toUpperCase();
            let parmContrato = this.contrato.toUpperCase();
            let parmCosto = this.rangoCosto;
            this.listadoFiltro = this.listadoCompontente1;
            console.log(this.listadoFiltro)
            if (parmEmpresa != "" || null) {
                this.listadoFiltro = this.listadoFiltro.filter(function (x) {
                    return (x.empresa.includes(parmEmpresa))
                });
            }
            if (parmObra != "" || null) {
                this.listadoFiltro = this.listadoFiltro.filter(function (x) {
                    return (x.obra.includes(parmObra))
                });
            }
            if (parmContrato != "" || null) {
                this.listadoFiltro = this.listadoFiltro.filter(function (x) {
                    return (x.numeroContrato.includes(parmContrato))
                });
            }
            if (!(this.parmAnio == null || this.parmAnio == '')) {
                this.listadoFiltro = this.listadoFiltro.filter(x =>
                    x.periodo == this.parmAnio
                );
            }
            if (!(this.parmTipo == null || this.parmTipo == '')) {
                this.listadoFiltro = this.listadoFiltro.filter(x =>
                    x.tiposObra == this.parmTipo
                );
            }
            if (!(this.parmDependencia == null || this.parmDependencia == '')) {
                this.listadoFiltro = this.listadoFiltro.filter(x =>
                    x.dependencia == this.parmDependencia
                );
            }
            this.listadoFiltro = this.listadoFiltro.filter(reg =>
                Math.trunc(reg.montoTotal) <= parmCosto[1] && Math.trunc(reg.montoTotal) >= parmCosto[0]
            )
            console.log(parmCosto[1]);
            console.log(this.listadoFiltro)

        },

        mostrarItem(item) {
            let me = this;
            this.selected = [];
            this.selected.push(item);
            this.tab = 'Conceptos';
            this.seleccionado = item.numeroContrato;
            this.idConcurso = item.concursoId;
            this.avanceFinanciero = item.avanceFinanciero ?? 0;
            this.avanceFisico = item.avanceFisico ?? 0;
            this.descripcion = item.obra;
            this.lat = 0;
            this.lng = 0;
            this.coordenadas = "0, 0";
            this.myCoordinates = { lat: 0, lng: 0 };
            console.log(this.selected);

            axios.get('api/historicoContratos/listarConceptos/' + this.seleccionado).then(function (response) {
                console.log(response.data);
                me.listadoConceptos = response.data;
            }).catch(function (error) {
                //Se agrega elemento a la lista por default
                console.log(error);
            });

            if (this.idConcurso) {
            axios.get('api/concursos/MostrarUbicacion/' +  this.idConcurso).then(function(response){
                var prueba = response.data.coordenadasFinales.split(",");
                me.coordenadas = response.data.coordenadasFinales;
                me.lat = prueba[0];
                me.lng = prueba[1];
                me.myCoordinates.lat = me.lat;
                me.myCoordinates.lng = me.lng;
                console.log(response.data.coordenadasFinales);
            }).catch(function (error) {
                console.log(error);
            });}
        },

        paginaSiguiente() {
            if (this.paginaActual < this.totalPaginas) {
                this.paginaActual++;
            }
        },

        paginaAnterior() {
            if (this.paginaActual > 1) {
                this.paginaActual--;
            }
        },

        paginaSiguienteConceptos() {
            if (this.paginaActualConceptos < this.totalPaginasConceptos) {
                this.paginaActualConceptos++;
            }
        },

        paginaAnteriorConceptos() {
            if (this.paginaActualConceptos > 1) {
                this.paginaActualConceptos--;
            }
        }

    },
}
</script>


<style>
    .modulo-tab {
    width: 100%;
}

.cortina-enter-active,
.cortina-leave-active {
    transition: all 0.35s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.cortina-enter-from {
    opacity: 0;
    transform: translateX(25px);
}

.cortina-leave-to {
    opacity: 0;
    transform: translateX(-25px);
}

.seccion_actividades:after{
    content: none !important;
    width: none !important;
}
</style>